<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    },
    RoofStructure: {
      type: Object,
      required: false
    }
  },
  methods: {
    async generateReadableUpdateRoofStructure() {
      let contentHtml = ``;
      for (let update of this.updates) {
        contentHtml = this.generateRegularActivityString(contentHtml, update);
      }
      this.setReadableUpdateProps(contentHtml);
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "ADD_ROOF_STRUCTURE_SUCCESS":
            this.generateReadableGeneric({
              content: "added a new roof structure.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "ADD_ROOF_STRUCTURE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to add a new roof structure.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_ROOF_STRUCTURE_SUCCESS":
            await this.generateReadableUpdateRoofStructure();
            break;
          case "UPDATE_ROOF_STRUCTURE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to update roof structure.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_ROOF_STRUCTURE_SUCCESS":
            this.generateReadableGeneric({
              content: "deleted a roof structure.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_ROOF_STRUCTURE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to delete roof structure.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_DELETE_ROOF_STRUCTURE_SUCCESS":
            this.generateReadableGeneric({
              content: this.bulkDeletionWording,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_DELETE_ROOF_STRUCTURE_FAILURE":
            this.generateReadableFailGeneric({
              content: this.bulkDeletionWording,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_RESTORE_ROOF_STRUCTURE_SUCCESS":
            this.generateReadableGeneric({
              content: this.bulkRestorationWording,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_RESTORE_ROOF_STRUCTURE_FAILURE":
            this.generateReadableFailGeneric({
              content: this.bulkRestorationWording,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  },
  computed: {
    bulkDeletionWording() {
      const count = this?.activity?.data?.roofStructureIds?.length || 0;
      return count > 1
        ? `deleted ${count} roof structures.`
        : `deleted 1 roof structure.`;
    },
    bulkRestorationWording() {
      const count = this?.activity?.data?.roofStructureIds?.length || 0;
      return count > 1
        ? `restored ${count} roof structures.`
        : `restored 1 roof structure.`;
    }
  }
};
</script>

<style></style>
